import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

import SectionHeader from "./SectionHeader";
import InputField from "./InputField";
import { SET_ACCESS_TOKEN, SET_PROFILE_AUTH } from "../../../redux/action/auth/type";
import ChangePhoneSheet from "./ChangePhoneSheet";

const ProfileContent = () => {

    const accessToken = useSelector(state => state.auth.accessToken)

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const [cookies, setCookies] = useCookies()

    // گرفتن پروفایل از redux
    const profile = useSelector(state => state.auth.profile);

    const [form, setForm] = useState({
        firstName: "",
        lastName: ""
    });
    const [phoneSheetOpen, setPhoneSheetOpen] = useState(false);

    // ----------------------
    // 🔥 state های جدید
    // ----------------------
    const [firstNameState, setFirstNameState] = useState("");
    const [lastNameState, setLastNameState] = useState("");
    const [phoneState, setPhoneState] = useState("");

    // ----------------------
    // 🔥 useEffect برای مقداردهی اولیه
    // ----------------------
    useEffect(() => {
        setFirstNameState(profile?.firstName || "درحال دریافت نام ...");
        setLastNameState(profile?.lastName || "درحال دریافت نام خانوادگی ...");
        setPhoneState(profile?.phone || "درحال دریافت شماره تماس شما ...");
    }, [profile]);
    // ----------------------

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });

        // 🔥 همزمان state های جدید را نیز آپدیت می‌کنیم
        if (e.target.name === "firstName") setFirstNameState(e.target.value);
        if (e.target.name === "lastName") setLastNameState(e.target.value);
    };


    const validateName = (name) => {
        const regex = /[0-9۰-۹]/;
        return !regex.test(name);
    };

    const refreshAccess = async () => {
        try {

        const res = await axios.post(
            "https://my-sarad-back.liara.run/api/auth/refresh-token",
            {refreshToken: cookies?.refreshToken}
        );

        const newAccess = res.data?.accessToken;

        // ذخیره در Redux
        dispatch({ type: SET_ACCESS_TOKEN, payload: newAccess });

        return newAccess;
        } catch (err) {
        return null;
        }
    };

    const handleUpdateProfile = async () => {

        const newFirstName = form.firstName || profile?.firstName;
        const newLastName = form.lastName || profile?.lastName;

        if (!validateName(newFirstName) || !validateName(newLastName)) {
            toast.error("نام یا نام خانوادگی شما نامعتبر است");
            return;
        }

        setLoading(true);

        const sendRequest = async (token) => {
            return await axios.post(
                "https://my-sarad-back.liara.run/api/user/profile",
                {
                    firstName: newFirstName?.trim(),
                    lastName: newLastName?.trim(),
                },
                {
                    headers: {
                        authorization: `Bearer ${token}`
                    }
                }
            );
        };

        try {

            // ✅ تلاش اول با accessToken فعلی
            await sendRequest(accessToken);

        } catch (error) {

            // ✅ اگر 401 بود یعنی accessToken منقضی شده
            if (error.response?.status === 401) {

                const newAccessToken = await refreshAccess();

                if (!newAccessToken) {
                    toast.error("نشست شما منقضی شده است، لطفا دوباره وارد شوید");
                    setLoading(false);
                    return;
                }

                try {
                    // ✅ تلاش دوم با توکن جدید
                    await sendRequest(newAccessToken);
                } catch (err) {
                    toast.error("خطا در بروزرسانی اطلاعات");
                    setLoading(false);
                    return;
                }

            } else {
                toast.error("خطا در بروزرسانی اطلاعات");
                setLoading(false);
                return;
            }
        }

        // ✅ اگر اینجا رسید یعنی عملیات موفق بوده (چه بار اول چه بعد از refresh)

        const updatedProfile = {
            ...profile,
            firstName: newFirstName,
            lastName: newLastName
        };

        dispatch({
            type: SET_PROFILE_AUTH,
            payload: updatedProfile
        });

        toast.success("اطلاعات با موفقیت بروزرسانی شد");

        setLoading(false);
    };

    return (
        <div className="max-w-2xl mx-auto">

            {/* Header */}
            <div className="flex flex-col items-center mb-10">

                <div className="w-24 h-24 rounded-full bg-gradient-to-br from-[#543389] to-[#8b6bd9] flex items-center justify-center text-white text-3xl font-bold shadow-xl mb-4 border-4 border-white">
                    {(profile?.firstName?.[0] || "S")}
                    {(profile?.lastName?.[0] || "A")}
                </div>

                <h2 className="text-xl font-bold text-slate-800">
                    {firstNameState} {lastNameState}
                </h2>

                <span className="mt-1 px-3 py-1 bg-purple-100 text-[#543389] text-xs font-bold rounded-full">
                    {profile?.role === "admin" ? "مدیر سیستم" : profile?.role === "staff" ? 'نیروی سالن' : "کاربر"}
                </span>

            </div>

            <div className="space-y-6">

                <SectionHeader title="اطلاعات فردی" icon="👤" />

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                    <InputField
                        label="نام"
                        name="firstName"
                        value={firstNameState}
                        placeholder="درحال دریافت نام ..."
                        onChange={handleChange}
                    />

                    <InputField
                        label="نام خانوادگی"
                        name="lastName"
                        value={lastNameState}
                        placeholder="درحال دریافت نام خانوادگی ..."
                        onChange={handleChange}
                    />

                </div>


                <div className="pt-4 border-t border-slate-100">

                    <SectionHeader title="امنیت و تماس" icon="🔒" />

                    <div className="relative">

                        <InputField
                            label="شماره موبایل"
                            value={phoneState}
                            disabled={true}
                            helper="شماره موبایل غیرقابل تغییر است"
                        />

                        <button
                            onClick={() => setPhoneSheetOpen(true)}
                            className="absolute left-2 top-9 text-xs font-bold text-[#543389] hover:text-[#8b6bd9] bg-purple-50 px-3 py-1.5 rounded-lg border border-purple-100"
                        >
                            تغییر شماره
                        </button>

                    </div>

                </div>


                <div className="pt-8">

                    <button
                        onClick={handleUpdateProfile}
                        disabled={loading}
                        className="w-full h-12 rounded-xl bg-gradient-to-r from-[#543389] to-[#8b6bd9] text-white font-bold shadow-lg hover:scale-[1.01] transition flex items-center justify-center gap-2"
                    >
                        {loading ? (
                            <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                        ) : "ذخیره تغییرات"}
                    </button>

                </div>

            </div>
            
            <ChangePhoneSheet
                open={phoneSheetOpen}
                onClose={() => setPhoneSheetOpen(false)}
            />

        </div>
    );
};

export default ProfileContent;